import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Header from './components/Header';
import Footer from './components/Footer';

import Post from './layouts/Post';
import Video from './layouts/Video';
import { dark, white } from 'react-components/dist/values/colors/colors';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';
import { Button } from 'react-components/dist/buttons/Button';
import { FontsFiles } from 'react-components/dist/values/fonts/files/fontsFiles';

const Wrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: ${white};
`;

const LoaderButton = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0px 72px 0px;
`;

const NoMorePosts = styled.div`
  text-align: center;
  font: ${secondaryFont.large};
  color: ${dark};
`;

const loadMorePost = () => {
  let postsAmount = window.posts.length;
  let postsRequest = new XMLHttpRequest();
  postsRequest.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {
      let posts = JSON.parse(postsRequest.responseText);
      if (posts.length === 0) {
        ReactDOM.render(
          <NoMorePosts>
            {window.lang === 'en' ? 'No more posts to show.' : 'Vous avez atteint le dernier article.'}
            <br />
            {window.lang === 'en'
              ? 'Come back in a few or subscribe to stay up-to-date!'
              : 'Revenez bientôt ou abonnez-vous pour rester à jour!'}
          </NoMorePosts>,
          document.getElementById('morePosts')
        );
        return;
      }
      let count = 0;
      posts.map((post, i) => {
        let index = postsAmount + i - 1;
        let postData = {
          title: post.title.rendered,
          id: post.id,
          content: post.content.rendered,
          url: post.link
        };

        let container = document.createElement('div');
        let mainContainer = document.getElementById('main-content');
        let postContent;
        let intro = post.excerpt.rendered;
        let renderedIntro = document.createElement('div');
        renderedIntro.innerHTML = intro;
        intro = renderedIntro.innerText;

        postData.intro = intro;

        let type = post['_embedded']['wp:term'][0][0].name;

        if (post.lang !== window.lang) {
          window.posts.push(postData);
          return false;
        }

        count++;

        if (type === 'Video') {
          postData.videoPreview = post['video_preview'];
          postContent = (
            <div>
              <Video
index={index}
active={false}
right={index % 2 === 1}
post={postData} />
            </div>
          );
        } else {
          postData.thumbnail = post['_embedded']['wp:featuredmedia'][0].source_url;
          postContent = (
            <div>
              <Post
index={index}
active={false}
right={index % 2 === 1}
post={postData} />
            </div>
          );
        }
        mainContainer.appendChild(container);
        ReactDOM.render(postContent, container);
        window.posts.push(postData);
      });
      if (count === 0) loadMorePost();
    }
  };

  let postsAlreadyShown = '';
  for (let i = 0; i < window.posts.length; i++) postsAlreadyShown += window.posts[i].id + ',';

  let url = '/wp-json/wp/v2/posts?_embed&exclude=' + postsAlreadyShown;
  postsRequest.open('GET', url, true);
  postsRequest.send();
};

export default () => {
  FontsFiles();
  return (
    <Wrapper>
      <Header lang={window.lang} />
      <div id={'main-content'}>
        {window.posts.map((post, i) => {
          if (post.type === 'Video')
            return (
              <div>
                <Video
index={i}
active={window.currentPost === post.id}
right={i % 2 === 1}
post={post} />
              </div>
            );

          return (
            <div>
              <Post
index={i}
active={window.currentPost === post.id}
right={i % 2 === 1}
post={post} />
            </div>
          );
        })}
      </div>

      <LoaderButton id={'morePosts'}>
        <Button
          onClick={e => {
            loadMorePost();
          }}
        >
          {window.lang === 'fr' ? "Plus d'articles!" : 'More Articles Please!'}
        </Button>
      </LoaderButton>
      <Footer lang={window.lang} />
    </Wrapper>
  );
};
